import { render } from "./sideBar.vue?vue&type=template&id=31b9a026&scoped=true"
import script from "./sideBar.vue?vue&type=script&lang=js"
export * from "./sideBar.vue?vue&type=script&lang=js"

import "./sideBar.vue?vue&type=style&index=0&id=31b9a026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b9a026"]])

export default __exports__